var _ellipse, _ellipse2, _path, _line, _defs, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasureABox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 40,
    viewBox: "0 0 90 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 20,
    rx: 16,
    ry: 12,
    fill: "#c8c8c8",
    stroke: "#8a8a8a",
    strokeWidth: 1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68,
    cy: 20,
    rx: 16,
    ry: 12,
    fill: "#c8c8c8",
    stroke: "#8a8a8a",
    strokeWidth: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 20 H52",
    stroke: "#8a8a8a",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 34,
    x2: 38,
    y2: 34,
    stroke: "#e53935",
    strokeWidth: 2,
    markerStart: "url(#m)",
    markerEnd: "url(#m)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "m",
    markerWidth: 4,
    markerHeight: 4,
    refX: 2,
    refY: 2,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "#e53935"
  })))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 31,
    x2: 6,
    y2: 37,
    stroke: "#e53935",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 31,
    x2: 38,
    y2: 37,
    stroke: "#e53935",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasureABox);
export default __webpack_public_path__ + "static/media/measure_a_box.e17b7cb5f7a1bb5078ae333ed4efb6de.svg";
export { ForwardRef as ReactComponent };